import React from 'react'
import { Box, Border, Flex, Input, Caps, ButtonTransparent } from 'rebass'
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import styled from 'styled-components'

const StyledInput = styled(Input)`
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`
const StyledButtonTransparent = styled(ButtonTransparent)`
  font-size: 0.75rem;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  &:focus {
    color: white;
  }
`
const EmailForm = styled.form`
  display: flex;
  // width: 100%;
  flex-grow: 1;
  align-items: center;
  margin-bottom: 0;
`

const CustomForm = () => {
  return (
    <Box width="100%" style={{ maxWidth: '40rem' }}>
      <Flex align="center">
        <Caps letterSpacing="0.1em" mr={3}>
          Sign up for updates:
        </Caps>
        <EmailForm
          action="https://thenatureofcities.us14.list-manage.com/subscribe/post?u=eccb2d994d282f2bd7a08f451&amp;id=8e396ce55f"
          method="POST"
        >
          <Border
            border={0}
            borderColor="white"
            borderBottom={1}
            style={{ flexGrow: 1 }}
          >
            <StyledInput
              type="email"
              name="EMAIL"
              placeholder="Email Address"
              id="mce-EMAIL"
              boxShadow={0}
              borderRadius={0}
              borderColor="white"
            />
          </Border>
          <Border
            border={0}
            borderColor="white"
            borderBottom={1}
            style={{ alignSelf: 'stretch' }}
          >
            <Flex style={{ height: '100%' }}>
              <StyledButtonTransparent
                type="submit"
                value="Sign Up"
                name="subscribe"
                id="mc-embedded-subscribe"
                px={2}
                py={2}
                borderRadius={0}
              >
                Submit
              </StyledButtonTransparent>
            </Flex>
          </Border>
        </EmailForm>
      </Flex>
    </Box>
  )
}

const Newsletter = () => (
  <Box px={4} py={2} bg="#4BC169" color="white">
    <Flex ml={3} align="center">
      <MailchimpSubscribe
        url="https://thenatureofcities.us14.list-manage.com/subscribe/post?u=eccb2d994d282f2bd7a08f451&amp;id=8e396ce55f"
        render={({ subscribe, status, message }) => (
          <CustomForm
            status={status}
            message={message}
            onValidated={formData => subscribe(formData)}
          />
        )}
      />
    </Flex>
  </Box>
)

export default Newsletter



// WEBPACK FOOTER //
// ./src/components/Newsletter.js